import React, { useState, useEffect } from "react";
import Modal from "../Modal";

export default function ModalEditarMiembro({ token, miembro, onClose, onSave }) {
  const [form, setForm] = useState({ ...miembro });
  const [loading, setLoading] = useState(false);

  const inputClass =
    "w-full border border-slate-200 rounded-lg px-3 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-200 focus:border-indigo-400";

  // Convierte fecha ISO a YYYY-MM-DD para input type="date"
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const d = new Date(dateString);
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  };

  const fechaLarga = (valor) =>
    valor ? new Date(valor).toLocaleDateString("es-MX", { day: "2-digit", month: "long", year: "numeric", timeZone: "UTC" }) : "Sin registrar";

  useEffect(() => {
    setForm({
      ...miembro,
      nacimiento: formatDate(miembro.nacimiento),
      aniversario: formatDate(miembro.aniversario),
    });
  }, [miembro]);

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const res = await fetch(`/api/miembros/${miembro.id_miembro}`, {
        method: "PUT",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(form),
      });
      if (!res.ok) throw new Error("No se pudo actualizar el miembro");
      onSave();
      onClose();
    } catch (error) {
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal open={true} onClose={onClose} title="Editar miembro" maxWidth="max-w-lg">
      <div>
        <div className="space-y-3">
          <div>
            <label className="block text-xs font-medium text-slate-700 mb-1">
              Nombre <span className="text-rose-500">*</span>
            </label>
            <input
              className={inputClass}
              placeholder="Nombre"
              value={form.nombre || ""}
              onChange={(e) => setForm({ ...form, nombre: e.target.value })}
            />
          </div>

          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="block text-xs font-medium text-slate-700 mb-1">Apellido paterno</label>
              <input
                className={inputClass}
                placeholder="Apellido paterno"
                value={form.paterno || ""}
                onChange={(e) => setForm({ ...form, paterno: e.target.value })}
              />
            </div>
            <div>
              <label className="block text-xs font-medium text-slate-700 mb-1">Apellido materno</label>
              <input
                className={inputClass}
                placeholder="Apellido materno"
                value={form.materno || ""}
                onChange={(e) => setForm({ ...form, materno: e.target.value })}
              />
            </div>
          </div>

          <div>
            <label className="block text-xs font-medium text-slate-700 mb-1">Sexo</label>
            <select
              className={inputClass}
              value={form.sexo || ""}
              onChange={(e) => setForm({ ...form, sexo: e.target.value })}
            >
              <option value="">-- Selecciona --</option>
              <option value="M">Masculino</option>
              <option value="F">Femenino</option>
            </select>
          </div>

          <div>
            <label className="block text-xs font-medium text-slate-700 mb-1">Dirección</label>
            <input
              className={inputClass}
              placeholder="Dirección"
              value={form.direccion || ""}
              onChange={(e) => setForm({ ...form, direccion: e.target.value })}
            />
          </div>

          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="block text-xs font-medium text-slate-700 mb-1">Teléfonos</label>
              <input
                className={inputClass}
                placeholder="Teléfonos"
                value={form.telefonos || ""}
                onChange={(e) => setForm({ ...form, telefonos: e.target.value })}
              />
            </div>
            <div>
              <label className="block text-xs font-medium text-slate-700 mb-1">Correo electrónico</label>
              <input
                className={inputClass}
                type="email"
                placeholder="Correo electrónico"
                value={form.email || ""}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
              />
            </div>
          </div>

          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="block text-xs font-medium text-slate-700 mb-1">Nacimiento</label>
              <input
                className={inputClass}
                type="date"
                value={form.nacimiento || ""}
                onChange={(e) => setForm({ ...form, nacimiento: e.target.value })}
              />
            </div>
            <div>
              <label className="block text-xs font-medium text-slate-700 mb-1">Aniversario</label>
              <input
                className={inputClass}
                type="date"
                value={form.aniversario || ""}
                onChange={(e) => setForm({ ...form, aniversario: e.target.value })}
              />
            </div>
          </div>

          {/* Se llenan solas al registrar el bautismo / la aceptación en Administración > Reuniones */}
          <div className="grid grid-cols-2 gap-3 rounded-lg bg-slate-50 border border-slate-100 p-3">
            <div>
              <p className="text-xs font-medium text-slate-500 mb-0.5">Fecha de bautismo</p>
              <p className="text-sm text-slate-800">{fechaLarga(miembro.fecha_bautismo)}</p>
            </div>
            <div>
              <p className="text-xs font-medium text-slate-500 mb-0.5">Fecha de ingreso</p>
              <p className="text-sm text-slate-800">{fechaLarga(miembro.fecha_ingreso)}</p>
            </div>
            <p className="col-span-2 text-[11px] text-slate-400">Se registran desde Administración › Reuniones.</p>
          </div>
        </div>

        <div className="flex justify-end gap-2 mt-4 pt-3 border-t border-slate-100">
          <button
            onClick={onClose}
            className="px-3.5 py-1.5 text-sm rounded-lg border border-slate-200 text-slate-600 hover:bg-slate-50 transition"
          >
            Cancelar
          </button>
          <button
            onClick={handleSubmit}
            disabled={loading}
            className="px-3.5 py-1.5 text-sm rounded-lg bg-indigo-600 hover:bg-indigo-700 disabled:opacity-60 text-white font-medium transition"
          >
            {loading ? "Guardando..." : "Guardar"}
          </button>
        </div>
      </div>
    </Modal>
  );
}
